import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import TinaResponsiveAsset from 'components/TinaResponsiveAsset';
import dynamic from 'next/dynamic';
import type { FullWidthImage as T } from './types';
import { blockPadV, blockW, blockPadH } from 'theme/mixins/padding';
import axios from 'axios';
import { Maybe } from '.tina/__generated__/types';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

const Wrapper = styled.div`
  ${() => blockPadV()};
  background: ${({ theme }) => theme.themeColors.bg};
`;

interface IContainer {
  specialBottomPadding?: Maybe<boolean> | undefined;
  horizontalPadding?: boolean;
}

const Container = styled.div<IContainer>`
  display: flex;

  ${blockW()}
  margin: 3px;
  ${({ theme }) => theme.mq.md`
    margin: auto;
  `}
  img {
    object-fit: cover;
    height: 100%;
  }
  svg {
    border-radius: 1rem;
    ${({ theme }) => theme.mq.md`
      border-radius: 1.5rem;
    `}
  }

  // these equate to the 'lg' padding size in the cms
  ${({ specialBottomPadding }) => specialBottomPadding && `margin-bottom: 3.75rem;`}
  ${({ specialBottomPadding, theme }) => theme.mq.md`
    ${specialBottomPadding && `margin-bottom: 5.675rem;`}
    ${blockPadH()}
  `}
`;

const FullWidthImage: React.FC<T> = ({
  respImage,
  lottieFp,
  specialBottomPadding,
  horizontalPadding
}: T) => {
  const [lottie, setLottie] = useState('');
  const fetchLottie = async () => {
    if (lottieFp) {
      const res = await axios.get(lottieFp);
      if (res?.status === 200) setLottie(res?.data);
    }
  };

  useEffect(() => {
    fetchLottie();
  }, []);

  return (
    <Wrapper>
      <Container
        specialBottomPadding={specialBottomPadding}
        horizontalPadding={!!horizontalPadding}
      >
        {lottie ? <Lottie animationData={lottie} loop={true} /> : null}
        {respImage ? <TinaResponsiveAsset asset={respImage} /> : null}
      </Container>
    </Wrapper>
  );
};

export default FullWidthImage;
